import { useState } from "react";
import { Input, Pagination, Flex } from "antd";
import BlogItem from "~/components/Blog/BlogItem";
import './style.css'
import { useTranslation } from "react-i18next";
import useHome from "../home/hooks/useBlog";
import { useDebouncedState } from "~/hooks";

const PAGE_SIZE = 8;

const BlogListView = () => {
  const {
    value: search,
    setValue: setSearch,
    debounced: debouncedSearch,
  } = useDebouncedState("", 500);
  const [page, setPage] = useState(1);
  const { t } = useTranslation("blog");
  const { blogs } = useHome({
    page,
    pageSize: PAGE_SIZE,
    name: debouncedSearch,
  });

  const blogList = blogs?.data ?? [];
  const total = blogs?.meta?.pagination.total ?? 0;

  return (
    <div className="dev-blog-page">
      <div className="dev-blog-page-inner">
        {/* Header */}
        <div className="dev-blog-page-header">
          <span className="dev-section-comment">// tin-tức</span>
          <h1 className="dev-blog-page-title">{t('blog.name') || 'Tin tức'}</h1>
        </div>

        {/* Search */}
        <div className="dev-blog-search-wrapper">
          <div className="dev-blog-search-prefix">$</div>
          <Input
            value={search}
            placeholder={t('blog.placeholder_search') || 'Tìm kiếm bài viết...'}
            allowClear
            onChange={e => setSearch(e.target.value)}
            className="dev-blog-search-input"
          />
        </div>

        {/* Blog grid */}
        <div className="dev-blog-grid">
          {blogList.map((blog: any) => (
            <div key={blog.id} className="dev-blog-card-wrap">
              <BlogItem data={blog} />
            </div>
          ))}
          {blogList.length === 0 && (
            <div className="dev-blog-empty">
              <span style={{ color: "#64748B", fontFamily: "'JetBrains Mono', monospace", fontSize: 13 }}>
                $ No posts found matching query.
              </span>
            </div>
          )}
        </div>

        {/* Pagination */}
        {total > PAGE_SIZE && (
          <div className="dev-blog-pagination">
            <Pagination
              current={page}
              pageSize={PAGE_SIZE}
              total={total}
              onChange={setPage}
              showSizeChanger={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogListView;
